import styled from 'styled-components';

export const TransferItemContainer = styled.div`
  width: 100%;
  background-color: ${({ theme }) => theme.palette.NL0};
  padding: 16px;
  border-radius: 8px;
  @media ${({ theme }) => `(min-width: ${theme.breakPoint.LARGE_1X})`} {
    width: 505px;
  }
`;
export const BodyWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  height: fit-content;
  @media ${({ theme }) => `(min-width: ${theme.breakPoint.LARGE_1X})`} {
    height: 55px;
  }
`;

export const RadioButton = styled.input`
  width: 20px;
  height: 20px;
  accent-color: ${({ theme }) => theme.palette.burntSienna};
`;
export const TransferTypeWrapper = styled.div`
  display: flex;
  flex-direction: column;
  cursor: default;
`;
export const PriceWrapper = styled.div`
  text-align: right;
  margin-left: auto;
  align-items: end;
  display: flex;
  flex-direction: column;
`;
export const PriceInfoWrapper = styled.div`
  margin-top: auto;
  margin-bottom: -1px;
`;
export const InfoWrapper = styled.div`
  display: flex;
  gap: 2px;
`;
